import { Keyframes, keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { FC } from "react";

import { Text } from "@livechat/design-system-react-components";

interface IProps {
  text: string;
  baseColor: string;
  highlightColor: string;
  speed: number;
  className?: string;
}

export const TextHighlight: FC<IProps> = ({ text, baseColor, highlightColor, speed, className }) => {
  return (
    <HighlightText data-testid="text-highlight" className={className}>
      {text.split("").map((char, index) => (
        <Letter key={index} delay={index * speed} baseColor={baseColor} highlightColor={highlightColor}>
          {char === " " ? "\u00A0" : char}
        </Letter>
      ))}
    </HighlightText>
  );
};

const getHighlightAnimation = (baseColor: string, highlightColor: string): Keyframes => keyframes`
  0% {
    color: ${baseColor}; 
  }
  50% {
    color: ${highlightColor}; 
  }
  100% {
    color: ${baseColor}; 
  }
`;

const HighlightText = styled(Text)`
  display: inline-flex;
`;

const Letter = styled.span<{ delay: number; baseColor: string; highlightColor: string }>`
  position: relative;
  display: inline-block;
  animation: ${({ baseColor, highlightColor }): Keyframes => getHighlightAnimation(baseColor, highlightColor)} 1s linear
    infinite;
  animation-delay: ${({ delay }): number => delay}s;
  color: ${({ baseColor }): string => baseColor};
  white-space: pre;
`;
